import { delegate } from '@js/util/delegate.js'

document.addEventListener('click', delegate('[data-scroll-indicator]', e => {
  const currentSection = e.target.closest('.main > *')

  if (!currentSection || !currentSection.nextElementSibling) {
    return
  }

  currentSection.nextElementSibling.scrollIntoView(true)
}))
